import React, { useState } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { BsUpcScan } from 'react-icons/bs';
import BarcodeScanner from './BarcodeScanner';

const SearchWithBarcode = ({ value, onChange, placeholder = 'Search' }) => {
  const [showScanner, setShowScanner] = useState(false);

  const handleScan = (code) => {
    onChange({ target: { value: code } });
    setShowScanner(false);
  };

  return (
    <div>
      <InputGroup className='my-3'>
        <Form.Control 
          value={value}
          onChange={onChange} 
          placeholder={placeholder} 
        />
        <Button variant="warning" onClick={() => setShowScanner(!showScanner)}>
          <BsUpcScan />
        </Button>
      </InputGroup>
      {showScanner && <BarcodeScanner onScan={handleScan} />}
    </div>
  );
};

export default SearchWithBarcode;
